import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { safeFormat } from "@/lib/dates";
import { Send, Search, FileText, Wrench, Rocket, FlaskConical, CheckCircle2, GitMerge } from "lucide-react";
function getSteps(ticket) {
    return [
        {
            label: "Submitted",
            icon: Send,
            status: "new",
            timestamp: ticket.createdAt,
        },
        {
            label: "Investigating",
            icon: Search,
            status: "investigating",
            timestamp: ticket.investigationStartedAt,
        },
        {
            label: "Issue Created",
            icon: FileText,
            status: "issue_created",
            timestamp: ticket.investigationCompletedAt,
        },
        {
            label: "Fix In Progress",
            icon: Wrench,
            status: "fixing",
            timestamp: ticket.fixStartedAt,
        },
        {
            label: "PR Ready",
            icon: FlaskConical,
            status: "staging_ready",
            timestamp: ticket.stagingReadyAt,
        },
        {
            label: "Deploying to Staging",
            icon: Rocket,
            status: "deploying",
            timestamp: ticket.deployStartedAt,
        },
        {
            label: "Testing on Staging",
            icon: FlaskConical,
            status: "testing",
            timestamp: ticket.testingStartedAt,
        },
        {
            label: "Approved",
            icon: CheckCircle2,
            status: "approved",
            timestamp: ticket.approvedAt,
        },
        {
            label: "Merged",
            icon: GitMerge,
            status: "merged",
            timestamp: ticket.mergedAt,
        },
    ];
}
const STATUS_ORDER = [
    "new",
    "investigating",
    "awaiting_reporter",
    "issue_created",
    "fixing",
    "fix_failed",
    "staging_ready",
    "deploying",
    "testing",
    "approved",
    "merged",
    "closed",
    "wont_fix",
    "duplicate",
];
function getStatusIndex(status) {
    return STATUS_ORDER.indexOf(status);
}
export function TicketTimeline({ ticket }) {
    const steps = getSteps(ticket);
    const currentStatusIndex = getStatusIndex(ticket.status);
    return (_jsxs("div", { className: "space-y-1", children: [_jsx("h3", { className: "mb-3 text-sm font-medium text-muted-foreground", children: "Lifecycle" }), _jsx("div", { className: "space-y-0", children: steps.map((step, index) => {
                    const stepIndex = getStatusIndex(step.status);
                    const isCompleted = step.timestamp !== undefined && stepIndex < currentStatusIndex;
                    const isCurrent = step.status === ticket.status;
                    const isFuture = stepIndex > currentStatusIndex;
                    return (_jsxs("div", { className: "flex gap-3", children: [_jsxs("div", { className: "flex flex-col items-center", children: [_jsx("div", { className: cn("flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 transition-colors", isCompleted && "border-green-500 bg-green-500/15 text-green-400", isCurrent && "border-primary bg-primary/15 text-primary ring-2 ring-primary/20", isFuture && "border-border bg-background text-muted-foreground/30"), children: _jsx(step.icon, { className: "h-3.5 w-3.5" }) }), index < steps.length - 1 && (_jsx("div", { className: cn("w-0.5 flex-1 min-h-[20px]", isCompleted ? "bg-green-500/40" : "bg-border") }))] }), _jsxs("div", { className: "pb-4", children: [_jsx("p", { className: cn("text-sm font-medium leading-7", isCurrent && "text-primary", isFuture && "text-muted-foreground/50"), children: step.label }), step.timestamp && !isFuture && (_jsx("p", { className: "text-xs text-muted-foreground", children: safeFormat(step.timestamp, "MMM d, yyyy h:mm a") }))] })] }, step.label));
                }) })] }));
}
